import React from 'react';
import QRCode from 'qrcode.react';

const Popup = ({ qrCode, onClose }) => {
  return (
    <div className="popup-overlay">
      <div className="popup">
        <button className="close-btn" onClick={onClose}>
          Close
        </button>
        <QRCode size={256} value={qrCode} />
      </div>
    </div>
  );
};

export default Popup;
